import React from 'react'
import styled, { StyledProps } from 'styled-components'

const SectionBody = styled.div`
  display: grid;
  grid-gap: 24px;
`
const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const SectionTitle = styled.h3`
  margin: 0 0 16px 0;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 20px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.color.secondary200};
`

const LabeledContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
`
const LabelStyled = styled.div`
  color: ${props => props.theme.color.onPrimaryDark};
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  opacity: 0.48;
  margin-bottom: 8px;
`

// exportable

const FormContentBody = styled.form`
  display: grid;
  grid-gap: 24px;
  padding: 16px 24px;
`

const FormContentFooter = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 72px;
  box-shadow: 0px -1px 0px rgba(0, 0, 0, 0.08);
  padding: 0 24px;
`

const FormContentWrapper = styled.div<StyledProps<{}>>`
  border-radius: 8px;
  background: ${({ theme }) => theme.color.onPrimaryLight};
`

const FormButtonsSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  background: ${({ theme }) => theme.color.onPrimaryLight};

  & > *:not(:last-child) {
    margin-right: 20px;
  }
`

const LabeledContainer: React.FC<{ label: string; children?: React.ReactNode }> = ({ children, label }) => {
  return (
    <LabeledContainerStyled>
      <LabelStyled>{label}</LabelStyled>
      {children}
    </LabeledContainerStyled>
  )
}

const FormSection: React.FC<{ title: string; className?: string; testId?: string; children?: React.ReactNode }> = ({
  title,
  className,
  children,
  testId,
}) => (
  <SectionWrapper className={className} data-test-id={testId}>
    <SectionTitle>{title}</SectionTitle>
    <SectionBody>{children}</SectionBody>
  </SectionWrapper>
)

const FormSectionTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`

export const FormComponents = {
  LabeledContainer,
  FormSection,
  FormSectionTextBlock,
  FormContentBody,
  FormContentFooter,
  FormContentWrapper,
  FormButtonsSection,
}
